function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStateOfHealth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 32 24.001",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.861 3.4535e-4a1.5002 1.5002 0 0 0-1.3613 0.94141l-3.7637 9.3887h-6.2363a1.5 1.5 0 0 0-1.5 1.5 1.5 1.5 0 0 0 1.5 1.5h7.25a1.5002 1.5002 0 0 0 1.3926-0.94141l2.5371-6.3262 4.9883 16.863a1.5002 1.5002 0 0 0 2.8789-0.0059l2.793-9.5898h7.1602a1.5 1.5 0 0 0 1.5-1.5 1.5 1.5 0 0 0-1.5-1.5h-8.2852a1.5002 1.5002 0 0 0-1.4414 1.0801l-1.6777 5.7637-4.7637-16.1a1.5002 1.5002 0 0 0-1.4707-1.0742z",
    color: "#000000",
    colorRendering: "auto",
    dominantBaseline: "auto",
    fill: "#000",
    imageRendering: "auto",
    shapeRendering: "auto",
    "solid-color": "#000000",
    stopColor: "#000000",
    strokeWidth: 0,
    style: {
      fontFeatureSettings: "normal",
      fontVariantAlternates: "normal",
      fontVariantCaps: "normal",
      fontVariantEastAsian: "normal",
      fontVariantLigatures: "normal",
      fontVariantNumeric: "normal",
      fontVariantPosition: "normal",
      fontVariationSettings: "normal",
      inlineSize: 0,
      isolation: "auto",
      mixBlendMode: "normal",
      shapeMargin: 0,
      shapePadding: 0,
      textDecorationColor: "#000000",
      textDecorationLine: "none",
      textDecorationStyle: "solid",
      textIndent: 0,
      textOrientation: "mixed",
      textTransform: "none",
      whiteSpace: "normal"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStateOfHealth);
export default __webpack_public_path__ + "static/media/state_of_health.c394714755c15b0184941be37053066c.svg";
export { ForwardRef as ReactComponent };